import { productOptions } from '@/utils/common';

export const getFormFields = () => [
  {
    name: 'productId',
    componentName: 'dropdown',
    params: {
      i18nLabel: 'waybills.product',
      options: productOptions(),
    },
    rules: [{ required: true }],
  },
];
